/**
 * Functions everything video.
 *
 * @package schnee
 */

/**
 * Auto-generate poster from video's first frame
 * if no poster attribute is set.
 */
function autoGeneratePoster(video) {
    if (video.poster) return;

    video.preload = 'metadata';
    video.muted = true;

    function capturePoster() {
        video.currentTime = 1;
    }

    function onSeeked() {
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas.getContext('2d').drawImage(video, 0, 0);

        try {
            video.poster = canvas.toDataURL('image/jpeg', 0.8);
        } catch (e) {
            // Cross-origin video — poster generation not possible
        }

        video.currentTime = 0;
        video.muted = false;
        video.removeEventListener('seeked', onSeeked);
    }

    if (video.readyState >= 1) {
        capturePoster();
    } else {
        video.addEventListener('loadedmetadata', capturePoster, { once: true });
    }

    video.addEventListener('seeked', onSeeked, { once: true });
}

export function videoControls() {
    const allVideoWrapper = document.querySelectorAll('.video-wrap');

    for (let i = 0; i < allVideoWrapper.length; i++) {
        let video = allVideoWrapper[i].querySelector('video');
        let playButton = allVideoWrapper[i].querySelector('.video-play');

        // Auto-generate poster if missing
        if (video) {
            autoGeneratePoster(video);
        }

        [video, playButton].forEach(item => {
            item.addEventListener("click", function () {
                if (video.paused == true) {
                    video.play();
                    video.setAttribute('controls', 'controls');
                    playButton.classList.add('d-none');
                } else {
                    video.pause();
                    video.removeAttribute('controls', 'controls');
                    playButton.classList.remove('d-none');
                }
            });
        })
    }
}
